import React from 'react';

// Logo "Signal Ember" de OSS. Vectorial (SVG + wordmark Audiowide),
// escala sin pérdida. La onda va ámbar → amarillo y la letra O celeste.
const AMBER = '#f59e0b';
const YELLOW = '#facc15';
const OBLUE = '#38bdf8';

const Wave = ({ w, id }) => (
    <svg width={w} height={w * 0.42} viewBox="0 0 64 32" fill="none" style={{ display: 'block' }} aria-hidden="true">
        <defs>
            <linearGradient id={id} x1="0" y1="0" x2="1" y2="0">
                <stop offset="0" stopColor={AMBER} />
                <stop offset="1" stopColor={YELLOW} />
            </linearGradient>
        </defs>
        <path d="M6 16 C 14 3 25 3 31 16 S 50 29 58 16" stroke={'url(#' + id + ')'} strokeWidth="6" strokeLinecap="round" fill="none" />
        <circle cx="6" cy="16" r="5" fill={AMBER} />
        <circle cx="58" cy="16" r="5" fill={YELLOW} />
    </svg>
);

// size = tamaño en px del wordmark. ssColor: color de "SS" según el fondo.
export default function OssLogo(props) {
    const size = props.size || 28;
    const id = 'ossgrad-' + (props.id || 'x');
    const ssColor = props.ssColor || '#0f172a';
    const oColor = props.oColor || OBLUE;
    const tagColor = props.tagColor || '#94a3b8';
    const tagline = props.tagline === true;

    return (
        <span className="oss-logo" style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1 }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.28 }}>
                <Wave w={size * 1.7} id={id} />
                <span className="oss-brand" style={{ fontSize: size, lineHeight: 1, letterSpacing: '-0.01em', whiteSpace: 'nowrap' }}>
                    <span style={{ color: oColor }}>O</span><span style={{ color: ssColor }}>SS</span>
                </span>
            </span>
            {tagline ? (
                <span className="oss-brand" style={{ fontSize: size * 0.24, letterSpacing: '0.34em', textTransform: 'uppercase', color: tagColor, marginTop: size * 0.2 }}>
                    Sales System
                </span>
            ) : null}
        </span>
    );
}



// WEBPACK FOOTER //
// ./src/Components/Common/OssLogo.js